<template>
  <div class="w-100" ref="formRef">
    <div class="card shadow overflow-hidden p-0 mx-0" :class="{ hide: submitted }">
      <form class="w-100" method="post" novalidate @submit.prevent="submitForm">
        <div class="card-body px-4 py-4">
          <!-- Barrio Input -->
          <div class="form-group mb-4" :class="{ error: searchBarrioError }">
            <label class="col-md-12 font-PM text-gray mb-3 px-0" for="cubierto">Barrio</label>
            <div class="col-md-12 px-0">
              <div
                class="wrapper-select-search w-100 d-flex justify-content-between align-items-center ico-blue ico-left select-box font-AR">
                <div class="ln-multiselect dropdown w-100" ref="dropdownRef">
                  <button
                    class="btn btn-secondary font-AR tracking-normal dropdown-toggle w-100 text-left p-0 d-flex align-items-center rounded-lg"
                    type="button" id="dropdownMenuButton" data-toggle="dropdown" aria-haspopup="true"
                    @click="dropdownOpen = !dropdownOpen" aria-expanded="false">
                    <div class="bg-light search-icon-box border-right position-relative">
                      <div class="search-icon"></div>
                    </div>
                    <p class="mb-0 pl-3">{{ selectedBarrio.length > 0 ? selectedBarrio[0].barrio : 'Buscar un barrio' }}
                    </p>
                  </button>
                  <div class="dropdown-menu w-100 mt-0"
                    :class="{ 'smallerHeight': searchBarriosError, show: dropdownOpen }"
                    aria-labelledby="dropdownMenuButton">
                    <input type="text" v-model="form.searchTerm" placeholder="Filtrar"
                      class="form-control search-filter mx-auto mb-2 font-AR">
                    <a class="dropdown-item full-width-item d-flex align-items-center" href="#"
                      v-for="(option, index) in filteredBarrios" :key="index" @click.prevent="selectBarrio(option)">
                      {{ option.barrio }}
                    </a>
                    <p v-if="searchBarriosError" class="dropdown-item">Sin resultados</p>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- Superficie Cubierta Input -->
          <div class="form-group row flex-column" :class="{ error: cubiertoError }">
            <label class="col font-PM text-gray mb-3" for="cubierto">Superficie cubierta</label>
            <div class="col">
              <div class="content-element bg-white border border-borders rounded-lg overflow-hidden">
                <div class="element-form-ico w-100 text-primary d-flex align-items-stretch">
                  <div
                    class="pre bg-light border-right border-borders d-flex justify-content-center align-items-center p-2">
                    <h2 class="font-PM text-nowrap px-2 mb-0">m<sup>2</sup></h2>
                  </div>
                  <input v-model="form.cubierto" type="number"
                    class="form-control h-auto form-control-lg border-0 text-primary text-left font-AR" id="cubierto"
                    name="cubierto" placeholder="120" maxlength="10" required @blur="markAsTouched('cubierto')" />
                </div>
              </div>
              <p class="error-messages small text-danger my-2 font-PM" v-if="cubiertoError">
                {{ cubiertoError }}
              </p>
              <p class="error-messages small text-danger my-2 font-PM"
                v-else-if="touched.cubierto && !isNaN(form.cubierto) && form.cubierto === ''">
                Debe ser un número válido
              </p>
            </div>
          </div>

          <!-- Superficie Semicubierta (balcón) Input -->
          <div class="form-group row flex-column" :class="{ error: semiCubiertoBalconError }">
            <label class="col font-PM text-gray mb-3" for="semiCubiertoBalcon">Superficie semicubierta (balcón)</label>
            <div class="col">
              <div class="content-element bg-white border border-borders rounded-lg overflow-hidden">
                <div class="element-form-ico w-100 text-primary d-flex align-items-stretch">
                  <div
                    class="pre bg-light border-right border-borders d-flex justify-content-center align-items-center p-2">
                    <h2 class="font-PM text-nowrap px-2 mb-0">m<sup>2</sup></h2>
                  </div>
                  <input v-model="form.semiCubiertoBalcon" type="number"
                    class="form-control h-auto form-control-lg border-0 text-primary text-left font-AR"
                    id="semiCubiertoBalcon" name="semiCubiertoBalcon" placeholder="15" maxlength="10" required
                    @blur="markAsTouched('semiCubiertoBalcon')" />
                </div>
              </div>
              <p class="error-messages small text-danger my-2 font-PM" v-if="semiCubiertoBalconError">
                {{ semiCubiertoBalconError }}
              </p>
              <p class="error-messages small text-danger my-2 font-PM"
                v-else-if="touched.semiCubiertoBalcon && !isNaN(form.semiCubiertoBalcon) && form.semiCubiertoBalcon === ''">
                Debe ser un número válido
              </p>
            </div>
          </div>

          <!-- Superficie Descubierta (terraza) Input -->
          <div class="form-group row flex-column" :class="{ error: semiCubiertoTerrazaError }">
            <label class="col font-PM text-gray mb-3" for="semiCubiertoTerraza">Superficie descubierta (terraza)</label>
            <div class="col">
              <div class="content-element bg-white border border-borders rounded-lg overflow-hidden">
                <div class="element-form-ico w-100 text-primary d-flex align-items-stretch">
                  <div
                    class="pre bg-light border-right border-borders d-flex justify-content-center align-items-center p-2">
                    <h2 class="font-PM text-nowrap px-2 mb-0">m<sup>2</sup></h2>
                  </div>
                  <input v-model="form.semiCubiertoTerraza" type="number"
                    class="form-control h-auto form-control-lg border-0 text-primary text-left font-AR"
                    id="semiCubiertoTerraza" name="semiCubiertoTerraza" placeholder="30" maxlength="10" required
                    @blur="markAsTouched('semiCubiertoTerraza')" />
                </div>
              </div>
              <p class="error-messages small text-danger my-2 font-PM" v-if="semiCubiertoTerrazaError">
                {{ semiCubiertoTerrazaError }}
              </p>
              <p class="error-messages small text-danger my-2 font-PM"
                v-else-if="touched.semiCubiertoTerraza && !isNaN(form.semiCubiertoTerraza) && form.semiCubiertoTerraza === ''">
                Debe ser un número válido
              </p>
            </div>
          </div>

          <!-- Amenities Toggle -->
          <div
            class="form-group row flex-column flex-sm-row no-gutters justify-content-between align-items-center border border-borders rounded p-3">
            <label class="col col-xl-7 font-PM text-gray pr-0 pr-sm-4 my-2 my-sm-1">Amenities</label>
            <div class="content-element bg-transparent wrapper-btn-drop p-1 my-2 my-sm-1">
              <div class="row no-gutters justify-content-center align-items-center">
                <div class="col-6 order-1">
                  <a :class="{ 'selected': !form.amenities, 'move-circle': form.amenities }"
                    class="btn btn-text btn-sm font-R text-nowrap active-circle-button-left text-gray text-uppercase w-100 px-2 py-0 mb-0"
                    @click="toggleAmenities">no</a>
                </div>
                <div class="col-6 order-2">
                  <a :class="{ 'selected': form.amenities, 'move-circle': !form.amenities }"
                    class="btn btn-text btn-sm font-R text-nowrap active-circle-button-right text-gray text-uppercase w-100 px-2 py-0 mb-0"
                    @click="toggleAmenities">si</a>
                </div>
                <div :class="{ 'btn-drop': true, 'btn-drop-si': form.amenities, 'btn-drop-no': !form.amenities }"
                  class="btn btn-left rounded-pill bg-light border border-borders order-3 position-absolute py-0 move-circle">
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- Submit Button -->
        <div class="card-footer bg-transparent border-0 px-4 pt-2 pt-md-4 pb-0">
          <div class="row justify-content-center align-items-center">
            <div class="col-md-12">
              <div class="row no-gutters justify-content-end">
                <button type="submit" :disabled="!validated"
                  class="font-ARB btn btn-outline-primary rounded-pill cta-start mb-4 text-uppercase btn-square">
                  Ver resultado
                </button>
              </div>
            </div>
          </div>
        </div>
      </form>
    </div>

    <!-- Resultado -->
    <!--resultado-->
    <div class="col-lg-12 mb-4 mb-xl-5" v-if="submitted">
      <div class="row">
        <div class="col-md-12 card rounded-top-0 shadow overflow-hidden mx-0 py-3 mb-4">
          <div class="row no-gutters justify-content-center align-items-center bg-primary rounded py-5">
            <div class="col-md-9 text-center py-4 py-xl-5">
              <img src="/images/icons/percentage.svg" class="mb-4" alt="resultado">
              <div class="result">
                <div class="element-form-ico w-100 pre d-flex justify-content-center align-items-center text-white">
                  <h2 class="font-PB text-nowrap text-center mb-0">US$ <span id="cont-resultado">{{
                    formatCustomDecimal }}</span>
                  </h2>
                </div>
              </div>
              <p class="font-PM text-white mb-4 pb-3">Valor estimado de la propiedad</p>
              <div>
                <button type="button" @click="reset"
                  class="btn btn-secondary rounded-pill font-ARB text-uppercase btn-square">Volver a
                  calcular
                </button>
              </div>
            </div>
          </div>
        </div>
        <div class="col-md-12">
          <p class="small font-R text-gray"><b>Aclaración:</b> La valuación de venta es estimada. Hay que tener en
            cuenta que existen factores como la ubicación dentro del barrio, la calle, el estado del edificio y del
            inmueble, su distribución, entre otras características, que no están ponderados en este cálculo y que
            definen la tasación profesional que realiza un agente inmobiliario capacitado. Cada inmueble es un caso
            particular e inclusive dentro de un mismo barrio puede haber microzonas que defienden sus propios precios de
            venta.</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { computed, watchEffect, reactive, ref } from "vue";
import numeral from 'numeral';

export default {
  props: {
    barrios: {
      type: Array,
      required: true,
    },
  },
  setup(props) {
    const form = reactive({
      searchTerm: "",
      searchBarrio: "",
      semiCubiertoTerraza: "",
      cubierto: "",
      semiCubiertoBalcon: "",
      amenities: false,
      precio: 0
    });
    const touched = reactive({
      cubierto: false,
      semiCubiertoBalcon: false,
      semiCubiertoTerraza: false,
    });

    const formRef = ref(null);
    const dropdownRef = ref(null);
    const barrios = ref(props.barrios);
    const submitted = ref(false);
    const validated = ref(false);
    const dropdownOpen = ref(false);
    const searchBarrioError = ref("");
    const semiCubiertoTerrazaError = ref("");
    const cubiertoError = ref("");
    const semiCubiertoBalconError = ref("");
    const numeroValidoError = ref("");

    const selectedBarrio = ref([]);
    const toggleAmenities = () => {
      form.amenities = !form.amenities;
    };

    const invalid = ref(false);
    const filteredBarrios = computed(() => {
      if (!form.searchTerm) {
        return props.barrios;
      }
      return props.barrios.filter(barrio => barrio.barrio.toLowerCase().includes(form.searchTerm.toLowerCase()));
    });
    const selectBarrio = (option) => {
      selectedBarrio.value = [option];
      dropdownOpen.value = false;
    };
    const searchBarriosError = computed(() => filteredBarrios.value.length === 0);
    const validateForm = () => {
      let valid = true;

      if (selectedBarrio.value.length === 0) {
        searchBarrioError.value = "Ingrese un valor válido.";
        valid = false;
      } else {
        searchBarrioError.value = "";
      }

      if ((form.semiCubiertoTerraza === '' || isNaN(form.semiCubiertoTerraza)) && touched.semiCubiertoTerraza) {
        semiCubiertoTerrazaError.value = "Ingrese un valor válido.";
        valid = false;
      } else {
        semiCubiertoTerrazaError.value = "";
      }

      if ((form.cubierto === '' || isNaN(form.cubierto)) && touched.cubierto) {
        cubiertoError.value =
          "Ingrese un valor válido.";
        valid = false;
      } else {
        cubiertoError.value = "";
      }

      if ((form.semiCubiertoBalcon === '' || isNaN(form.semiCubiertoBalcon)) && touched.semiCubiertoBalcon) {
        semiCubiertoBalconError.value =
          "Ingrese un valor válido.";
        valid = false;
      } else {
        semiCubiertoBalconError.value = "";
      }

      validated.value = valid;
      return valid;
    };

    watchEffect(() => {
      if (submitted.value) {
        validateForm();
      }
    });

    const markAsTouched = (field) => {
      touched[field] = true;
      validateForm();
    };

    const submitForm = () => {
      markAsTouched('semiCubiertoTerraza');
      markAsTouched('cubierto');
      markAsTouched('semiCubiertoBalcon');

      if (validateForm()) {
        submitted.value = true;
        let precio = Number(selectedBarrio.value[0].precio);
        let cubierto = Number(form.cubierto);
        let balcon = form.semiCubiertoBalcon ? form.semiCubiertoBalcon * 0.5 : 0;
        let terraza = form.semiCubiertoTerraza ? form.semiCubiertoTerraza * 0.3 : 0;
        let amenities = form.amenities ? 1.15 : 1;
        form.precio = precio * (cubierto + balcon + terraza) * amenities;
      }
    };

    const formatCustomDecimal = computed(() => {
      let value = form.precio;
      let parsed = parseFloat(value).toFixed(2);
      let n1 = parsed.split('.');
      debugger;
      if (n1[1] == '00') {
        return numeral(parseInt(n1[0])).format('0,000');
      }
      return numeral(parseFloat(parsed)).format('0,0.00');
    });

    const reset = () => {
      submitted.value = false;
      form.searchTerm = "";
      form.searchBarrio = "";
      form.semiCubiertoTerraza = "";
      form.cubierto = "";
      form.semiCubiertoBalcon = "";
      form.amenities = false;
      form.precio = 0;
      touched.semiCubiertoTerraza = false;
      touched.cubierto = false;
      touched.semiCubiertoBalcon = false;
      semiCubiertoTerrazaError.value = "";
      cubiertoError.value = "";
      semiCubiertoBalconError.value = "";
    };

    return {
      form,
      toggleAmenities,
      selectedBarrio,
      barrios,
      submitted,
      validated,
      searchBarrioError,
      semiCubiertoTerrazaError,
      cubiertoError,
      semiCubiertoBalconError,
      numeroValidoError,
      submitForm,
      filteredBarrios,
      selectBarrio,
      formRef,
      dropdownRef,
      touched,
      searchBarriosError,
      dropdownOpen,
      submitted,
      formatCustomDecimal,
      reset,
      markAsTouched
    };
  },
};
</script>

<style lang="scss">
a {
  cursor: pointer;
}
</style>
